/**
 * @file 消息通知API
 * @author 小白
 */

import request from "@/utils/request";

// 站内信分页查询
export async function getStudentStationMessage(data) {
  return request.post("/studentStationMessage/list", data);
}

// 站内信设置已读
export async function setStudentStationMessageRead(data) {
  return request.put(`/studentStationMessage/read/${data}`);
}

// 学生意见反馈
export async function addAdvice(data) {
  return request.post("/student/advice/add", data);
}

// 查看我的通知-小红点通知数
export async function queryUnread() {
  return request.get("/studentStationMessage/queryUnread");
}

// 删除消息
export async function deleteStudentStationMessage(data) {
  return request.delete(`/studentStationMessage/delete/${data}`);
}